export default __webpack_public_path__ + "static/media/DSC088616443.177222c1.jpg";